<template>
    <div>
        <div class="card" :style="styles" @click="$emit('click', $event)">
            <div v-if="showTitleRow" class="row align-items-center">
                <div class="col"><h3 style="font-weight: 200;">{{ title }}</h3></div>
                <slot name="right-header-column"></slot>
            </div>
            <div v-if="showSeparator && title" class="row align-items-center"><div class="col"><hr style="width: 100%;"></div></div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: { 
            title: { 
                type: String, 
                default() { return '' }
            },
            showSeparator: {
                type: Boolean,
                default() { return true }
            },
            styles: {
                type: String,
                default: 'margin-bottom: 1rem; padding: 2rem 2rem 1rem;',
            },
            showTitleRow: {
                type: Boolean,
                default: true
            }
        }
    }
</script>